import {createAction, props} from '@ngrx/store';
import {UserStatistics} from '../entities/users.entity';

export enum UserActionTypes {
  ClearUserStatistics = '[UserStatistics] clear all user statistics',
  GetUserStatistics = '[UserStatistics] get user statistics',
  SetUserStatistics = '[UserStatistics] set user statistics',
}

const clearUserStatistics = createAction(UserActionTypes.ClearUserStatistics);
const getUserStatistics = createAction(UserActionTypes.GetUserStatistics, props<{ statistics: UserStatistics }>());
const setUserStatistics = createAction(UserActionTypes.SetUserStatistics, props<{ statistics: UserStatistics }>());

export const userActions = {
  clearUserStatistics,
  getUserStatistics,
  setUserStatistics
};
